<mydocma-app-container [options]="options" class="mydocma"></mydocma-app-container>